import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material';

export default function DynamicThemeProvider({ children }) {
  const webSettings = useSelector(state => state.webSettings.data);
  
  const theme = useMemo(() => {
    const primary = webSettings?.NAVBAR_TXT_COLOR || '#e69215';
    
    return createTheme({
      palette: {
        primary: {
          main: primary,
        },
        secondary: {
          main: "#FFFF"
        }
      },
      typography: {
        fontFamily: "'Poppins', sans-serif",
      },
      tab: {
        textTransform: 'none',
      }
    });
  }, [webSettings]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
